<section class="navbar mb-1 header-braedcrum">
  <ul>
    <li>
      <a>
        <div *ngIf="!isShop">
          <app-side-menu></app-side-menu>
        </div>
      </a>
    </li>
    <div
      *ngIf="!leftArrow"
      class="pull-left mt-sm align-self-center mt-1 ul-mobile"
    >
      <em (click)="scrollLeft()" class="pi pi-angle-left"></em>
    </div>

    <div #widgetsContent *ngIf="!isShowSlider" class="custom-slider-main">


      <li *ngFor="let category of categories" class="ul-mobile">
        <app-category-dropdown
          [categories]="category?.categories"
          [categoryId]="category.id"
          [categoryName]="category.categoryName"
        ></app-category-dropdown>
      </li>
    </div>

    <div
      *ngIf="rightArrow && categories.length > 10"
      class="pull-right mt-sm align-self-center mt-1 ul-mobile r-a pi-white"
    >
      <em
        (click)="scrollRight()"
        *ngIf="!isShowSlider"
        class="pi pi-angle-right"
      ></em>
    </div>
  </ul>
</section>
